<app-z-dialog
  [title]="data.title | translate"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <z-form-grid [formGroupRef]="data.formGroup!" [inputs]="data.inputs!"> </z-form-grid>
</ng-template>
<ng-template #buttonsTemplate>
  <z-button
    *ngIf="!data.formGroup?.disabled"
    [disabled]="!!data.formGroup?.invalid"
    icon="add_circle_outline"
    [label]="data.actionButton ? data.actionButton : ((data.isEditMode ? 'COMMON.EDIT' : 'COMMON.ADD') | translate)"
    (clicked)="confirm()"
  >
  </z-button>
</ng-template>
